import React from "react";
import  '../component/css/nwb.css';

const url = window.location.href;
// const url = "ulsterbank";
// const url = "rbs";
// const url = "natwest";
let brand ="rbs";
if (url.includes("ulsterbank")){
    brand = "ubn";
}
else if (url.includes("natwest")){
    brand = "nwb";
}

const Footer = () => {
    return (
        <div>
            <div className="spacer"><br class="ff" /></div>
{
                (() => {
                    if(brand==='nwb') {
                            return (
                                <div className="footer">
                <ul className="globalLinks">
                    <li className="first"><a href="https://www.natwest.com/global/legal.ashx"
                        title="Opens a new window to view Website terms & conditions" target="blank">Website terms &amp;
                        conditions</a></li>
                    <li><a href="https://www.natwest.com/global/privacy.ashx"
                        title="Opens a new window to view Privacy information" target="blank">Privacy</a></li>
                    <li><a href="https://www.natwest.com/global/security.ashx"
                        title="Opens a new window to view Security information" target="blank">Security</a></li>
                </ul>
            </div>
                            )
                        }
                        else if(brand==='ubn') {
                            return (
                                <div className="footer">
            <p style={{color:'#fff',fontSize:'16px',marginTop:'initial',float:'left',marginLeft:'15%'}}>Ulster Bank © 2008 | <a href="https://www.ulsterbank.co.uk/security" title="Opens a new window to access security information" target="blank">Security</a></p>
         </div>
                            )
                        }
                        else {
                            return (
                                <div id="footerContainer">
		    <div id="footer">
               <ol class="footer_navbar">
			        <li>
						<a href="https://www.rbs.co.uk/global/f/privacy.ashx" title="Opens a new window to view Privacy information" target="blank">Privacy</a>
					</li>
					<li>
						<a href="https://www.rbs.co.uk/global/f/security.ashx" title="Opens a new window to view Security information" target="blank">Security</a>
					</li>
					<li>
						<a href="https://www.rbs.co.uk/global/f/legal-info.ashx" title="Opens a new window to view Website terms & conditions" target="blank">Website terms & conditions</a>
					</li>
					<li className="last">
						The Royal Bank of Scotland © 2009
		    		</li>
		        </ol>
		    </div>
       </div>
                            )
                        }
                })()  
            }  

        
        
       </div>
       
        
    
  );
};
export default Footer;

